import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    buttonLabel: string;
    removeCaptionLabel: string;
    subtitle: string;
    subtext: string;
    title: string;
    mobileTitle: string;
    tooltipText: string;
    failedToAdd: string;
    offsetCheckboxLabel: string;
    assetStartTimeLabel: string;
    assetStartTimeDescription: (time: string) => string | React.ReactNode;
    startAtZeroLabel: string;
    startAtZeroDescription: string;
    menuGroupLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Upload button label */
            buttonLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "UploadCaptionsForm.buttonLabel?c=2x83m8ip19996", defaultMessage: "Upload" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Remove captions button label */
            removeCaptionLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "UploadCaptionsForm.removeCaptionLabel?c=k135wmgq6ah3", defaultMessage: "Remove caption" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Upload captions dialog subtitle */
            subtitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "UploadCaptionsForm.subtitle?c=14rycjh1j64zg", defaultMessage: "Supported file types include SRT or VTT." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Choose language dropdown label */
            subtext: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "UploadCaptionsForm.subtext?c=2hg1ilr1bji9j", defaultMessage: "Choose Language" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Upload captions dialog title */
            title: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "UploadCaptionsForm.title?c=fi7aboc03rzc", defaultMessage: "Drag and drop to upload Caption files" }));
                },
                enumerable: true,
                configurable: true
            },
            /**  Mobile upload captions dialog title */
            mobileTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "UploadCaptionsForm.mobileTitle?c=117jyl0l8d2pp", defaultMessage: "Upload Caption files" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Tooltip text */
            tooltipText: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "UploadCaptionsForm.tooltipText?c=3uhk01xrfevs8", defaultMessage: "Selected language will appear in Captions menu" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Error message shown when captions uploading failed */
            failedToAdd: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "UploadCaptionsForm.failedToAdd?c=2v1gkva8gh38i", defaultMessage: "Failed to add" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Checkbox text for time offset */
            offsetCheckboxLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "UploadCaptionsForm.offsetCheckboxLabel?c=29c6wduv9sq7a", defaultMessage: "Use upload timecode" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Asset start time label text */
            assetStartTimeLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "UploadCaptionsForm.assetStartTimeLabel?c=n5x1z6fdkhs5", defaultMessage: "Asset timecode" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description informing user that at what timecode their asset starts */
            assetStartTimeDescription: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (time: string) => __intl__.intl().formatMessage({ id: "UploadCaptionsForm.assetStartTimeDescription?c=3mowyqzvpyznu", defaultMessage: "Caption file assumes playback starts at {time}" }, { time: time }));
                },
                enumerable: true,
                configurable: true
            },
            /** Offset option fr assets that start at 0 */
            startAtZeroLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "UploadCaptionsForm.startAtZeroLabel?c=3fgu21e0svcrg", defaultMessage: "Upload timecode" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description for assets that start at 0 time */
            startAtZeroDescription: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "UploadCaptionsForm.startAtZeroDescription?c=1edjmlfsjzmdl", defaultMessage: "Caption file assumes playback starts at 00:00:00:00" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Caption time menu */
            menuGroupLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "UploadCaptionsForm.menuGroupLabel?c=31n0ks7nmrcvj", defaultMessage: "Caption timing" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
